import styled from 'styled-components';

import DispatchingListHeader from './component';

import { listHeaderStyles } from 'modules/fleet/list';

export default styled(DispatchingListHeader)`
  ${listHeaderStyles}

  .capacity {
    margin-left: 1.6rem;
  }
`;
